import styled from 'styled-components'

const RightActions = styled.div`
  margin-left: auto;
`

RightActions.displayName = 'RightActions'
export default RightActions
